<template>
<v-container style="max-width: 1280px">
  <v-row justify="center">
    <v-col cols="12" md="6">
      <v-card outlined>
        <v-card-subtitle>
          Step 1 / 5
        </v-card-subtitle>
        <v-progress-linear height="10" :value="progress" striped></v-progress-linear>
      </v-card>
    </v-col>
  </v-row>
  <v-row justify="center">
    <v-col cols="12" md="6">
      <v-card outlined>
        <v-sheet color="deep-purple lighten-1" dark>
          <v-card-title class="justify-center">
            Are You Religious?
          </v-card-title>
          <v-card-subtitle class="text-center white--text">
            (Choose Below)
          </v-card-subtitle>
        </v-sheet>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="issue_valid" lazy-validation>
            <v-select
              label="Select a Status"
              :items="religious_statuses"
              :rules="issue_rules"
              v-model="religious_status"
              outlined hide-details dense
            />
          </v-form>
          <christian-alert
            v-if="is_christian && major_issue != ''"
            :message="christian"
            :major_issue="major_issue"
          />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  
  <v-row justify="center">
    <v-col cols="12" md="6">
      <v-card outlined>
        <v-sheet color="deep-orange" dark>
          <v-card-title class="justify-center">
            Major Issue
          </v-card-title>
          <v-card-subtitle class="text-center white--text">
            What is your biggest struggle?<br>
            (Choose One)
          </v-card-subtitle>
        </v-sheet>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="issue_valid" lazy-validation>
            <v-select
              label="Select an Issue"
              class="mb-4"
              :items="issues"
              :rules="issue_rules"
              v-model="major_issue"
              outlined hide-details dense
            />
          </v-form>
          <v-alert class="mb-0" type="info" color="deep-orange" v-if="major_issue != ''">
            {{ message }}
          </v-alert>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <v-row justify="center">
    <v-col cols="12" md="6">
      <v-card outlined>
        <v-card-actions class="justify-center pa-4">
          <v-btn color="primary" :disabled="major_issue === ''" @click="finish">
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import major_issues from '../include/major-issues.json';
import ChristianAlert from '../components/ChristianAlert.vue';

export default {
  name: "Pre-Quiz",
  components: {
    ChristianAlert
  },
  data: () => ({
    issues: [],
    messages: [],
    christian_messages: [],
    major_issue: '',

    religious_status: '',
    religious_statuses: [
      'Christian',
      'Other',
      'None'
    ],

    issue_valid: false,
    issue_rules: [
      v => !!v || 'Selection is required',
      v => (v && v != '') || 'Name must be less than 10 characters'
    ],
  }),
  computed: {
    progress: function() {
      var progress = 0;
      if (this.religious_status !== '') {
        progress += 12.5;
      }

      if (this.major_issue != '') {
        progress += 12.5;
      }

      return progress;
    },

    message: function() {
      var index = this.issues.indexOf(this.major_issue);
      return this.messages[index];
    },

    christian: function() {
      var index = this.issues.indexOf(this.major_issue);
      return this.christian_messages[index];
    },

    is_christian: function() {
      return this.religious_status == 'Christian';
    }
  },
  methods: {
    finish: function() {
      var values = JSON.stringify({
        issue: major_issues.find(i => i.major_issue === this.major_issue),
        christian: this.is_christian
      });

      this.$router.push({
        path: '/initial',
        query: {
          major_issue: values
        }
      });
    }
  },
  mounted() {
    this.issues = major_issues.map(i => i.major_issue);
    this.messages = major_issues.map(i => i.message_first);
    this.christian_messages = major_issues.map(i => i.christian_first);
  }
}
</script>